// Complete Pokémon dataset for Pokémon Emerald (including Gen 1, 2, and 3)
export const pokemonData = [
  // Gen 1 Pokémon found in Emerald
  { id: 1, name: "Bulbasaur", types: ["Grass", "Poison"] },
  { id: 2, name: "Ivysaur", types: ["Grass", "Poison"] },
  { id: 3, name: "Venusaur", types: ["Grass", "Poison"] },
  { id: 4, name: "Charmander", types: ["Fire"] },
  { id: 5, name: "Charmeleon", types: ["Fire"] },
  { id: 6, name: "Charizard", types: ["Fire", "Flying"] },
  { id: 7, name: "Squirtle", types: ["Water"] },
  { id: 8, name: "Wartortle", types: ["Water"] },
  { id: 9, name: "Blastoise", types: ["Water"] },
  { id: 10, name: "Caterpie", types: ["Bug"] },
  { id: 11, name: "Metapod", types: ["Bug"] },
  { id: 12, name: "Butterfree", types: ["Bug", "Flying"] },
  { id: 13, name: "Weedle", types: ["Bug", "Poison"] },
  { id: 14, name: "Kakuna", types: ["Bug", "Poison"] },
  { id: 15, name: "Beedrill", types: ["Bug", "Poison"] },
  { id: 16, name: "Pidgey", types: ["Normal", "Flying"] },
  { id: 17, name: "Pidgeotto", types: ["Normal", "Flying"] },
  { id: 18, name: "Pidgeot", types: ["Normal", "Flying"] },
  { id: 19, name: "Rattata", types: ["Normal"] },
  { id: 20, name: "Raticate", types: ["Normal"] },
  { id: 21, name: "Spearow", types: ["Normal", "Flying"] },
  { id: 22, name: "Fearow", types: ["Normal", "Flying"] },
  { id: 23, name: "Ekans", types: ["Poison"] },
  { id: 24, name: "Arbok", types: ["Poison"] },
  { id: 25, name: "Pikachu", types: ["Electric"] },
  { id: 26, name: "Raichu", types: ["Electric"] },
  { id: 27, name: "Sandshrew", types: ["Ground"] },
  { id: 28, name: "Sandslash", types: ["Ground"] },
  { id: 29, name: "Nidoran♀", types: ["Poison"] },
  { id: 30, name: "Nidorina", types: ["Poison"] },
  { id: 31, name: "Nidoqueen", types: ["Poison", "Ground"] },
  { id: 32, name: "Nidoran♂", types: ["Poison"] },
  { id: 33, name: "Nidorino", types: ["Poison"] },
  { id: 34, name: "Nidoking", types: ["Poison", "Ground"] },
  { id: 35, name: "Cleffa", types: ["Normal"] },
  { id: 36, name: "Clefairy", types: ["Normal"] },
  { id: 37, name: "Clefable", types: ["Normal"] },
  { id: 38, name: "Vulpix", types: ["Fire"] },
  { id: 39, name: "Ninetales", types: ["Fire"] },
  { id: 40, name: "Jigglypuff", types: ["Normal"] },
  { id: 41, name: "Wigglytuff", types: ["Normal"] },
  { id: 42, name: "Zubat", types: ["Poison", "Flying"] },
  { id: 43, name: "Golbat", types: ["Poison", "Flying"] },
  { id: 44, name: "Oddish", types: ["Grass", "Poison"] },
  { id: 45, name: "Gloom", types: ["Grass", "Poison"] },
  { id: 46, name: "Vileplume", types: ["Grass", "Poison"] },
  { id: 47, name: "Paras", types: ["Bug", "Grass"] },
  { id: 48, name: "Parasect", types: ["Bug", "Grass"] },
  { id: 49, name: "Venonat", types: ["Bug", "Poison"] },
  { id: 50, name: "Venomoth", types: ["Bug", "Poison"] },
  { id: 51, name: "Diglett", types: ["Ground"] },
  { id: 52, name: "Dugtrio", types: ["Ground"] },
  { id: 53, name: "Meowth", types: ["Normal"] },
  { id: 54, name: "Persian", types: ["Normal"] },
  { id: 55, name: "Psyduck", types: ["Water"] },
  { id: 56, name: "Golduck", types: ["Water"] },
  { id: 57, name: "Mankey", types: ["Fighting"] },
  { id: 58, name: "Primeape", types: ["Fighting"] },
  { id: 59, name: "Growlithe", types: ["Fire"] },
  { id: 60, name: "Arcanine", types: ["Fire"] },
  { id: 61, name: "Poliwag", types: ["Water"] },
  { id: 62, name: "Poliwhirl", types: ["Water"] },
  { id: 63, name: "Poliwrath", types: ["Water", "Fighting"] },
  { id: 64, name: "Abra", types: ["Psychic"] },
  { id: 65, name: "Kadabra", types: ["Psychic"] },
  { id: 66, name: "Machop", types: ["Fighting"] },
  { id: 67, name: "Machoke", types: ["Fighting"] },
  { id: 68, name: "Machamp", types: ["Fighting"] },
  { id: 69, name: "Bellsprout", types: ["Grass", "Poison"] },
  { id: 70, name: "Weepinbell", types: ["Grass", "Poison"] },
  { id: 71, name: "Victreebel", types: ["Grass", "Poison"] },
  { id: 72, name: "Tentacool", types: ["Water", "Poison"] },
  { id: 73, name: "Tentacruel", types: ["Water", "Poison"] },
  { id: 74, name: "Geodude", types: ["Rock", "Ground"] },
  { id: 75, name: "Graveler", types: ["Rock", "Ground"] },
  { id: 76, name: "Golem", types: ["Rock", "Ground"] },
  { id: 77, name: "Ponyta", types: ["Fire"] },
  { id: 78, name: "Rapidash", types: ["Fire"] },
  { id: 79, name: "Slowpoke", types: ["Water", "Psychic"] },
  { id: 80, name: "Slowbro", types: ["Water", "Psychic"] },
  { id: 81, name: "Magnemite", types: ["Electric", "Steel"] },
  { id: 82, name: "Magneton", types: ["Electric", "Steel"] },
  { id: 83, name: "Farfetch'd", types: ["Normal", "Flying"] },
  { id: 84, name: "Doduo", types: ["Normal", "Flying"] },
  { id: 85, name: "Dodrio", types: ["Normal", "Flying"] },
  { id: 86, name: "Seel", types: ["Water"] },
  { id: 87, name: "Dewgong", types: ["Water", "Ice"] },
  { id: 88, name: "Grimer", types: ["Poison"] },
  { id: 89, name: "Muk", types: ["Poison"] },
  { id: 90, name: "Shellder", types: ["Water"] },
  { id: 91, name: "Cloyster", types: ["Water", "Ice"] },
  { id: 92, name: "Gastly", types: ["Ghost", "Poison"] },
  { id: 93, name: "Haunter", types: ["Ghost", "Poison"] },
  { id: 94, name: "Gengar", types: ["Ghost", "Poison"] },
  { id: 95, name: "Onix", types: ["Rock", "Ground"] },
  { id: 96, name: "Drowzee", types: ["Psychic"] },
  { id: 97, name: "Hypno", types: ["Psychic"] },
  { id: 98, name: "Krabby", types: ["Water"] },
  { id: 99, name: "Kingler", types: ["Water"] },
  { id: 100, name: "Voltorb", types: ["Electric"] },
  { id: 101, name: "Electrode", types: ["Electric"] },
  { id: 102, name: "Exeggcute", types: ["Grass", "Psychic"] },
  { id: 103, name: "Exeggutor", types: ["Grass", "Psychic"] },
  { id: 104, name: "Cubone", types: ["Ground"] },
  { id: 105, name: "Marowak", types: ["Ground"] },
  { id: 106, name: "Hitmonlee", types: ["Fighting"] },
  { id: 107, name: "Hitmonchan", types: ["Fighting"] },
  { id: 108, name: "Lickitung", types: ["Normal"] },
  { id: 109, name: "Koffing", types: ["Poison"] },
  { id: 110, name: "Weezing", types: ["Poison"] },
  { id: 111, name: "Rhyhorn", types: ["Ground", "Rock"] },
  { id: 112, name: "Rhydon", types: ["Ground", "Rock"] },
  { id: 113, name: "Chansey", types: ["Normal"] },
  { id: 114, name: "Tangela", types: ["Grass"] },
  { id: 115, name: "Kangaskhan", types: ["Normal"] },
  { id: 116, name: "Horsea", types: ["Water"] },
  { id: 117, name: "Seadra", types: ["Water"] },
  { id: 118, name: "Goldeen", types: ["Water"] },
  { id: 119, name: "Seaking", types: ["Water"] },
  { id: 120, name: "Staryu", types: ["Water"] },
  { id: 121, name: "Starmie", types: ["Water", "Psychic"] },
  { id: 122, name: "Mr. Mime", types: ["Psychic"] },
  { id: 123, name: "Scyther", types: ["Bug", "Flying"] },
  { id: 124, name: "Jynx", types: ["Ice", "Psychic"] },
  { id: 125, name: "Electabuzz", types: ["Electric"] },
  { id: 126, name: "Magmar", types: ["Fire"] },
  { id: 127, name: "Pinsir", types: ["Bug"] },
  { id: 128, name: "Tauros", types: ["Normal"] },
  { id: 129, name: "Magikarp", types: ["Water"] },
  { id: 130, name: "Gyarados", types: ["Water", "Flying"] },
  { id: 131, name: "Lapras", types: ["Water", "Ice"] },
  { id: 132, name: "Ditto", types: ["Normal"] },
  { id: 133, name: "Eevee", types: ["Normal"] },
  { id: 134, name: "Vaporeon", types: ["Water"] },
  { id: 135, name: "Jolteon", types: ["Electric"] },
  { id: 136, name: "Flareon", types: ["Fire"] },
  { id: 137, name: "Porygon", types: ["Normal"] },
  { id: 138, name: "Omanyte", types: ["Rock", "Water"] },
  { id: 139, name: "Omastar", types: ["Rock", "Water"] },
  { id: 140, name: "Kabuto", types: ["Rock", "Water"] },
  { id: 141, name: "Kabutops", types: ["Rock", "Water"] },
  { id: 142, name: "Aerodactyl", types: ["Rock", "Flying"] },
  { id: 143, name: "Snorlax", types: ["Normal"] },
  { id: 144, name: "Articuno", types: ["Ice", "Flying"] },
  { id: 145, name: "Zapdos", types: ["Electric", "Flying"] },
  { id: 146, name: "Moltres", types: ["Fire", "Flying"] },
  { id: 147, name: "Dratini", types: ["Dragon"] },
  { id: 148, name: "Dragonair", types: ["Dragon"] },
  { id: 149, name: "Dragonite", types: ["Dragon", "Flying"] },
  { id: 150, name: "Mewtwo", types: ["Psychic"] },
  { id: 151, name: "Mew", types: ["Psychic"] },
  
  // Gen 2 Pokémon found in Emerald
  { id: 152, name: "Chikorita", types: ["Grass"] },
  { id: 153, name: "Bayleef", types: ["Grass"] },
  { id: 154, name: "Meganium", types: ["Grass"] },
  { id: 155, name: "Cyndaquil", types: ["Fire"] },
  { id: 156, name: "Quilava", types: ["Fire"] },
  { id: 157, name: "Typhlosion", types: ["Fire"] },
  { id: 158, name: "Totodile", types: ["Water"] },
  { id: 159, name: "Croconaw", types: ["Water"] },
  { id: 160, name: "Feraligatr", types: ["Water"] },
  { id: 161, name: "Sentret", types: ["Normal"] },
  { id: 162, name: "Furret", types: ["Normal"] },
  { id: 163, name: "Hoothoot", types: ["Normal", "Flying"] },
  { id: 164, name: "Noctowl", types: ["Normal", "Flying"] },
  { id: 165, name: "Ledyba", types: ["Bug", "Flying"] },
  { id: 166, name: "Ledian", types: ["Bug", "Flying"] },
  { id: 167, name: "Spinarak", types: ["Bug", "Poison"] },
  { id: 168, name: "Ariados", types: ["Bug", "Poison"] },
  { id: 169, name: "Crobat", types: ["Poison", "Flying"] },
  { id: 170, name: "Chinchou", types: ["Water", "Electric"] },
  { id: 171, name: "Lanturn", types: ["Water", "Electric"] },
  { id: 172, name: "Pichu", types: ["Electric"] },
  { id: 173, name: "Cleffa", types: ["Normal"] },
  { id: 174, name: "Igglybuff", types: ["Normal"] },
  { id: 175, name: "Togepi", types: ["Normal"] },
  { id: 176, name: "Togetic", types: ["Normal", "Flying"] },
  { id: 177, name: "Natu", types: ["Psychic", "Flying"] },
  { id: 178, name: "Xatu", types: ["Psychic", "Flying"] },
  { id: 179, name: "Mareep", types: ["Electric"] },
  { id: 180, name: "Flaaffy", types: ["Electric"] },
  { id: 181, name: "Ampharos", types: ["Electric"] },
  { id: 182, name: "Bellossom", types: ["Grass"] },
  { id: 183, name: "Marill", types: ["Water"] },
  { id: 184, name: "Azumarill", types: ["Water"] },
  { id: 185, name: "Sudowoodo", types: ["Rock"] },
  { id: 186, name: "Politoed", types: ["Water"] },
  { id: 187, name: "Hoppip", types: ["Grass", "Flying"] },
  { id: 188, name: "Skiploom", types: ["Grass", "Flying"] },
  { id: 189, name: "Jumpluff", types: ["Grass", "Flying"] },
  { id: 190, name: "Aipom", types: ["Normal"] },
  { id: 191, name: "Sunkern", types: ["Grass"] },
  { id: 192, name: "Sunflora", types: ["Grass"] },
  { id: 193, name: "Yanma", types: ["Bug", "Flying"] },
  { id: 194, name: "Wooper", types: ["Water", "Ground"] },
  { id: 195, name: "Quagsire", types: ["Water", "Ground"] },
  { id: 196, name: "Espeon", types: ["Psychic"] },
  { id: 197, name: "Umbreon", types: ["Dark"] },
  { id: 198, name: "Murkrow", types: ["Dark", "Flying"] },
  { id: 199, name: "Slowking", types: ["Water", "Psychic"] },
  { id: 200, name: "Misdreavus", types: ["Ghost"] },
  { id: 201, name: "Unown", types: ["Psychic"] },
  { id: 202, name: "Wobbuffet", types: ["Psychic"] },
  { id: 203, name: "Girafarig", types: ["Normal", "Psychic"] },
  { id: 204, name: "Pineco", types: ["Bug"] },
  { id: 205, name: "Forretress", types: ["Bug", "Steel"] },
  { id: 206, name: "Dunsparce", types: ["Normal"] },
  { id: 207, name: "Gligar", types: ["Ground", "Flying"] },
  { id: 208, name: "Steelix", types: ["Steel", "Ground"] },
  { id: 209, name: "Snubbull", types: ["Normal"] },
  { id: 210, name: "Granbull", types: ["Normal"] },
  { id: 211, name: "Qwilfish", types: ["Water", "Poison"] },
  { id: 212, name: "Scizor", types: ["Bug", "Steel"] },
  { id: 213, name: "Shuckle", types: ["Bug", "Rock"] },
  { id: 214, name: "Heracross", types: ["Bug", "Fighting"] },
  { id: 215, name: "Sneasel", types: ["Dark", "Ice"] },
  { id: 216, name: "Teddiursa", types: ["Normal"] },
  { id: 217, name: "Ursaring", types: ["Normal"] },
  { id: 218, name: "Slugma", types: ["Fire"] },
  { id: 219, name: "Magcargo", types: ["Fire", "Rock"] },
  { id: 220, name: "Swinub", types: ["Ice", "Ground"] },
  { id: 221, name: "Piloswine", types: ["Ice", "Ground"] },
  { id: 222, name: "Corsola", types: ["Water", "Rock"] },
  { id: 223, name: "Remoraid", types: ["Water"] },
  { id: 224, name: "Octillery", types: ["Water"] },
  { id: 225, name: "Delibird", types: ["Ice", "Flying"] },
  { id: 226, name: "Mantine", types: ["Water", "Flying"] },
  { id: 227, name: "Skarmory", types: ["Steel", "Flying"] },
  { id: 228, name: "Houndour", types: ["Dark", "Fire"] },
  { id: 229, name: "Houndoom", types: ["Dark", "Fire"] },
  { id: 230, name: "Kingdra", types: ["Water", "Dragon"] },
  { id: 231, name: "Phanpy", types: ["Ground"] },
  { id: 232, name: "Donphan", types: ["Ground"] },
  { id: 233, name: "Porygon2", types: ["Normal"] },
  { id: 234, name: "Stantler", types: ["Normal"] },
  { id: 235, name: "Smeargle", types: ["Normal"] },
  { id: 236, name: "Tyrogue", types: ["Fighting"] },
  { id: 237, name: "Hitmontop", types: ["Fighting"] },
  { id: 238, name: "Smoochum", types: ["Ice", "Psychic"] },
  { id: 239, name: "Elekid", types: ["Electric"] },
  { id: 240, name: "Magby", types: ["Fire"] },
  { id: 241, name: "Miltank", types: ["Normal"] },
  { id: 242, name: "Blissey", types: ["Normal"] },
  { id: 243, name: "Raikou", types: ["Electric"] },
  { id: 244, name: "Entei", types: ["Fire"] },
  { id: 245, name: "Suicune", types: ["Water"] },
  { id: 246, name: "Larvitar", types: ["Rock", "Ground"] },
  { id: 247, name: "Pupitar", types: ["Rock", "Ground"] },
  { id: 248, name: "Tyranitar", types: ["Dark", "Rock"] },
  { id: 249, name: "Lugia", types: ["Psychic", "Flying"] },
  { id: 250, name: "Ho-Oh", types: ["Fire", "Flying"] },
  { id: 251, name: "Celebi", types: ["Psychic", "Grass"] },
  
  { id: 252, name: "Treecko", types: ["Grass"] },
  { id: 253, name: "Grovyle", types: ["Grass"] },
  { id: 254, name: "Sceptile", types: ["Grass"] },
  { id: 255, name: "Torchic", types: ["Fire"] },
  { id: 256, name: "Combusken", types: ["Fire", "Fighting"] },
  { id: 257, name: "Blaziken", types: ["Fire", "Fighting"] },
  { id: 258, name: "Mudkip", types: ["Water"] },
  { id: 259, name: "Marshtomp", types: ["Water", "Ground"] },
  { id: 260, name: "Swampert", types: ["Water", "Ground"] },
  { id: 261, name: "Poochyena", types: ["Dark"] },
  { id: 262, name: "Mightyena", types: ["Dark"] },
  { id: 263, name: "Zigzagoon", types: ["Normal"] },
  { id: 264, name: "Linoone", types: ["Normal"] },
  { id: 265, name: "Wurmple", types: ["Bug"] },
  { id: 266, name: "Silcoon", types: ["Bug"] },
  { id: 267, name: "Beautifly", types: ["Bug", "Flying"] },
  { id: 268, name: "Cascoon", types: ["Bug"] },
  { id: 269, name: "Dustox", types: ["Bug", "Poison"] },
  { id: 270, name: "Lotad", types: ["Water", "Grass"] },
  { id: 271, name: "Lombre", types: ["Water", "Grass"] },
  { id: 272, name: "Ludicolo", types: ["Water", "Grass"] },
  { id: 273, name: "Seedot", types: ["Grass"] },
  { id: 274, name: "Nuzleaf", types: ["Grass", "Dark"] },
  { id: 275, name: "Shiftry", types: ["Grass", "Dark"] },
  { id: 276, name: "Taillow", types: ["Normal", "Flying"] },
  { id: 277, name: "Swellow", types: ["Normal", "Flying"] },
  { id: 278, name: "Wingull", types: ["Water", "Flying"] },
  { id: 279, name: "Pelipper", types: ["Water", "Flying"] },
  { id: 280, name: "Ralts", types: ["Psychic"] },
  { id: 281, name: "Kirlia", types: ["Psychic"] },
  { id: 282, name: "Gardevoir", types: ["Psychic"] },
  { id: 283, name: "Surskit", types: ["Bug", "Water"] },
  { id: 284, name: "Masquerain", types: ["Bug", "Flying"] },
  { id: 285, name: "Shroomish", types: ["Grass"] },
  { id: 286, name: "Breloom", types: ["Grass", "Fighting"] },
  { id: 287, name: "Slakoth", types: ["Normal"] },
  { id: 288, name: "Vigoroth", types: ["Normal"] },
  { id: 289, name: "Slaking", types: ["Normal"] },
  { id: 290, name: "Nincada", types: ["Bug", "Ground"] },
  { id: 291, name: "Ninjask", types: ["Bug", "Flying"] },
  { id: 292, name: "Shedinja", types: ["Bug", "Ghost"] },
  { id: 293, name: "Whismur", types: ["Normal"] },
  { id: 294, name: "Loudred", types: ["Normal"] },
  { id: 295, name: "Exploud", types: ["Normal"] },
  { id: 296, name: "Makuhita", types: ["Fighting"] },
  { id: 297, name: "Hariyama", types: ["Fighting"] },
  { id: 298, name: "Azurill", types: ["Normal"] },
  { id: 299, name: "Nosepass", types: ["Rock"] },
  { id: 300, name: "Skitty", types: ["Normal"] },
  { id: 301, name: "Delcatty", types: ["Normal"] },
  { id: 302, name: "Sableye", types: ["Dark", "Ghost"] },
  { id: 303, name: "Mawile", types: ["Steel"] },
  { id: 304, name: "Aron", types: ["Steel", "Rock"] },
  { id: 305, name: "Lairon", types: ["Steel", "Rock"] },
  { id: 306, name: "Aggron", types: ["Steel", "Rock"] },
  { id: 307, name: "Meditite", types: ["Fighting", "Psychic"] },
  { id: 308, name: "Medicham", types: ["Fighting", "Psychic"] },
  { id: 309, name: "Electrike", types: ["Electric"] },
  { id: 310, name: "Manectric", types: ["Electric"] },
  { id: 311, name: "Plusle", types: ["Electric"] },
  { id: 312, name: "Minun", types: ["Electric"] },
  { id: 313, name: "Volbeat", types: ["Bug"] },
  { id: 314, name: "Illumise", types: ["Bug"] },
  { id: 315, name: "Roselia", types: ["Grass", "Poison"] },
  { id: 316, name: "Gulpin", types: ["Poison"] },
  { id: 317, name: "Swalot", types: ["Poison"] },
  { id: 318, name: "Carvanha", types: ["Water", "Dark"] },
  { id: 319, name: "Sharpedo", types: ["Water", "Dark"] },
  { id: 320, name: "Wailmer", types: ["Water"] },
  { id: 321, name: "Wailord", types: ["Water"] },
  { id: 322, name: "Numel", types: ["Fire", "Ground"] },
  { id: 323, name: "Camerupt", types: ["Fire", "Ground"] },
  { id: 324, name: "Torkoal", types: ["Fire"] },
  { id: 325, name: "Spoink", types: ["Psychic"] },
  { id: 326, name: "Grumpig", types: ["Psychic"] },
  { id: 327, name: "Spinda", types: ["Normal"] },
  { id: 328, name: "Trapinch", types: ["Ground"] },
  { id: 329, name: "Vibrava", types: ["Ground", "Dragon"] },
  { id: 330, name: "Flygon", types: ["Ground", "Dragon"] },
  { id: 331, name: "Cacnea", types: ["Grass"] },
  { id: 332, name: "Cacturne", types: ["Grass", "Dark"] },
  { id: 333, name: "Swablu", types: ["Normal", "Flying"] },
  { id: 334, name: "Altaria", types: ["Dragon", "Flying"] },
  { id: 335, name: "Zangoose", types: ["Normal"] },
  { id: 336, name: "Seviper", types: ["Poison"] },
  { id: 337, name: "Lunatone", types: ["Rock", "Psychic"] },
  { id: 338, name: "Solrock", types: ["Rock", "Psychic"] },
  { id: 339, name: "Barboach", types: ["Water", "Ground"] },
  { id: 340, name: "Whiscash", types: ["Water", "Ground"] },
  { id: 341, name: "Corphish", types: ["Water"] },
  { id: 342, name: "Crawdaunt", types: ["Water", "Dark"] },
  { id: 343, name: "Baltoy", types: ["Ground", "Psychic"] },
  { id: 344, name: "Claydol", types: ["Ground", "Psychic"] },
  { id: 345, name: "Lileep", types: ["Rock", "Grass"] },
  { id: 346, name: "Cradily", types: ["Rock", "Grass"] },
  { id: 347, name: "Anorith", types: ["Rock", "Bug"] },
  { id: 348, name: "Armaldo", types: ["Rock", "Bug"] },
  { id: 349, name: "Feebas", types: ["Water"] },
  { id: 350, name: "Milotic", types: ["Water"] },
  { id: 351, name: "Castform", types: ["Normal"] },
  { id: 352, name: "Kecleon", types: ["Normal"] },
  { id: 353, name: "Shuppet", types: ["Ghost"] },
  { id: 354, name: "Banette", types: ["Ghost"] },
  { id: 355, name: "Duskull", types: ["Ghost"] },
  { id: 356, name: "Dusclops", types: ["Ghost"] },
  { id: 357, name: "Tropius", types: ["Grass", "Flying"] },
  { id: 358, name: "Chimecho", types: ["Psychic"] },
  { id: 359, name: "Absol", types: ["Dark"] },
  { id: 360, name: "Wynaut", types: ["Psychic"] },
  { id: 361, name: "Snorunt", types: ["Ice"] },
  { id: 362, name: "Glalie", types: ["Ice"] },
  { id: 363, name: "Spheal", types: ["Ice", "Water"] },
  { id: 364, name: "Sealeo", types: ["Ice", "Water"] },
  { id: 365, name: "Walrein", types: ["Ice", "Water"] },
  { id: 366, name: "Clamperl", types: ["Water"] },
  { id: 367, name: "Huntail", types: ["Water"] },
  { id: 368, name: "Gorebyss", types: ["Water"] },
  { id: 369, name: "Relicanth", types: ["Water", "Rock"] },
  { id: 370, name: "Luvdisc", types: ["Water"] },
  { id: 371, name: "Bagon", types: ["Dragon"] },
  { id: 372, name: "Shelgon", types: ["Dragon"] },
  { id: 373, name: "Salamence", types: ["Dragon", "Flying"] },
  { id: 374, name: "Beldum", types: ["Steel", "Psychic"] },
  { id: 375, name: "Metang", types: ["Steel", "Psychic"] },
  { id: 376, name: "Metagross", types: ["Steel", "Psychic"] },
  { id: 377, name: "Regirock", types: ["Rock"] },
  { id: 378, name: "Regice", types: ["Ice"] },
  { id: 379, name: "Registeel", types: ["Steel"] },
  { id: 380, name: "Latias", types: ["Dragon", "Psychic"] },
  { id: 381, name: "Latios", types: ["Dragon", "Psychic"] },
  { id: 382, name: "Kyogre", types: ["Water"] },
  { id: 383, name: "Groudon", types: ["Ground"] },
  { id: 384, name: "Rayquaza", types: ["Dragon", "Flying"] },
  { id: 385, name: "Jirachi", types: ["Steel", "Psychic"] },
  { id: 386, name: "Deoxys", types: ["Psychic"] }
];
